exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation-back-container{position:relative;width:100%}.navigation-back-container .element{position:absolute;display:flex;justify-content:center;align-items:center;color:var(--boy-blue);cursor:pointer;font-size:.875em;z-index:1;padding:.25rem .75rem}.navigation-back-container .element:hover{background-color:var(--boy-blue-5);border-radius:.25rem;border-bottom:none}.navigation-back-container .element .arrow{margin-right:.5em;width:1rem;height:1rem}", ""]);

// exports
